import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    product: PropTypes.object,
};

export default class ProductRow extends React.Component{
    constructor(props){
        super(props);
    }

    render() {
        const {product} = this.props;
        const {upc, code, desc, spr, map} = product;

        return(
            <tr className='price-grit-row'>
                <td className='price-grid-cell'>{upc}</td>
                <td className='price-grid-cell'>{code}</td>
                <td className='price-grid-cell'>{desc}</td>
                <td className='price-grid-cell'>{spr}</td>
                <td className='price-grid-cell'>{map}</td>
            </tr>
        );
    }
}

ProductRow.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/PriceGridTable/ProductRow.js